exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-announce-___style__form___1A_6F{padding:1em 0 0}.web-flows-deal-announce-___style__formlabel___z1Orf{display:block;padding:.4em 0}.web-flows-deal-announce-___style__header___1rcGA{display:flex;justify-content:space-between;border-bottom:1px solid #e5e3e3}.web-flows-deal-announce-___style__h2___2A7hy{border-bottom:none!important}.web-flows-deal-announce-___style__close___1tiep{padding:0 .7em .7em 0}@media (max-width:599px){.web-flows-deal-announce-___style__toplevel___Ht_4C{padding:1em .5em 0}}", ""]);

// exports
exports.locals = {
	"form": "web-flows-deal-announce-___style__form___1A_6F",
	"formlabel": "web-flows-deal-announce-___style__formlabel___z1Orf",
	"header": "web-flows-deal-announce-___style__header___1rcGA",
	"h2": "web-flows-deal-announce-___style__h2___2A7hy",
	"close": "web-flows-deal-announce-___style__close___1tiep",
	"toplevel": "web-flows-deal-announce-___style__toplevel___Ht_4C"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/announce/style.css
// module id = 1337
// module chunks = 0